module.exports = __webpack_public_path__ + "static/media/empty_ticket_icon.ad5f6344.svg";